<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-input type="textarea" :autosize="{ minRows: 10, maxRows: 10 }" :maxlength="500" placeholder="500字以内" v-model="pdesc" style="margin-bottom: 10px;"></el-input>
      <el-checkbox v-model="checked">发送通知：{{notifyMsg}}</el-checkbox>
    </div>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="submitLoading">确认</el-button>
    </div>
  </div>
</template>

<script>
import { getFormData,postFormData } from "@/api/api";
import { updateResumePdescState, getCommonSysParam } from "@/api/url";

export default {
name: "updatePdescDialog",
  props: {
    value: Object
  },
  data() {
    return {
      pdesc: this.value.pdesc,
      userId: this.value.userId,
      checked: false,
      notifyMsg: '',
      submitLoading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    submit() {
      if(this.pdesc.length < 10) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '自我介绍不能少于10个字',
          type: 'warning'
        });
        return;
      }
      this.submitLoading = true
      let param = {};
      param['id'] = this.userId;
      param['pdesc'] = this.pdesc;
      param['notifyMsg'] = this.checked ? this.notifyMsg : '';
      postFormData(updateResumePdescState, param).then((data) => {
        if(data.code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'success'
          });
          this.$emit('confirm', this.pdesc)
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          });
        }
        this.submitLoading = false
      }).catch(()=>{
        this.submitLoading = false
      })
    },

    getCommon() {
      getFormData( getCommonSysParam ).then((data)=>{
        if(data.code == 200) {
            this.notifyMsg = data.data.updateResumePdescMsg
        }
      })
    }

  },
  mounted() {
    this.getCommon()
  }
}
</script>

<style scoped>

</style>
